import hooks from './shipment-transfer-stats.hooks';

export default (app) => {
  const service = app.service('api/shipment-transfer-stats');
  service.hooks(hooks);
};
